const onlineProvidersTestPayload = {
    "departureAddress": {
        "number": "9",
        "street": "Rue Scribe",
        "city": "Paris",
        "country": "France",
        "countryCode": "FR",
        "postalCode": "75009",
        "label": "9 Rue Scribe, 75009 Paris, France",
        "lat": 48.871493,
        "lng": 2.330266
    },
    "arrivalAddress": {
        "number":"",
        "street":"Allée du Marché",
        "city":"Créteil",
        "country":"France",
        "countryCode":"FR",
        "postalCode":"94000",
        "label":"All. du Marché, 94000 Créteil, France",
        "lat":48.7815665,
        "lng":2.4650647
    },
    "vehicleIdentificationConfirmed": [
        {
            "vehicle": {
                "make": "MERCEDES",
                "model": "CLASSE A",
                "bodyTypeTransport": "Berline",
                "plate": "ET-804-HT",
                "fuelTypeLabel": "Diesel",
                "fuelTypeNumber": 1,
                "towable": false,
                "nonRolling": false,
                "dimensions": null
            },
            "hiflowMapping": {
                "id": "49",
                "bodyType": "Berline",
                "idBodyType": "Berline"
            },
            "popValetMapping": {
                "id": "False",
                "large": false
            },
            "transportingWheelsMapping": {
                "id": "101",
                "bodyType": "Standard Car"
            },
            "driiveMeMapping": {
                "id": 2,
                "bodyType": "Berline"
            },
            "vehicleID": 1708947556726
        }
    ]
};

export default onlineProvidersTestPayload;
